var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from "react";
import { completedPage, submittedCredentials } from "../../../lib/Avo";
import Button from "../../../components/connect-ui/Button";
import Image from "../../../components/Image";
import RouteTitle from "../../../components/RouteTitle";
import TextField from "../../../components/connect-ui/TextField";
import useAppSelector from "../../../hooks/useAppSelector";
import useEventPublisher from "../../../hooks/useEventPublisher";
import { useLocation } from "react-router-dom";
import { useLoginMutation } from "../../../services/connect";
function loginFormReducer(state, nextState) {
    return __assign(__assign({}, state), nextState);
}
function LoginForm(_a) {
    var selectedIssuer = _a.selectedIssuer, onSubmit = _a.onSubmit;
    var commonAnalyticsProperties = useAppSelector(function (state) { return state.analytics.commonAnalyticsProperties; });
    var eventPublisher = useEventPublisher();
    var location = useLocation();
    var login = useLoginMutation({ fixedCacheKey: location.pathname })[0];
    var isDemo = (selectedIssuer === null || selectedIssuer === void 0 ? void 0 : selectedIssuer.id) === "demo";
    var defaultState = {
        username: isDemo ? "trellis1" : "",
        password: isDemo ? "password" : "",
        pin: "",
    };
    var _b = React.useReducer(loginFormReducer, defaultState), _c = _b[0], username = _c.username, password = _c.password, pin = _c.pin, setState = _b[1];
    function handleInputChange(_a) {
        var _b;
        var target = _a.target;
        setState((_b = {}, _b[target.name] = target.value, _b));
    }
    function handleSubmit(event) {
        event.preventDefault();
        onSubmit();
        submittedCredentials(__assign(__assign({}, commonAnalyticsProperties), { issuerId: (selectedIssuer === null || selectedIssuer === void 0 ? void 0 : selectedIssuer.id) || "", subIssuerId: null }));
        completedPage(__assign(__assign({}, commonAnalyticsProperties), { selectedOption: "Submit", optionSelected: "Submit" }));
        eventPublisher.submitCredentials();
        login({ username: username, password: password, pin: pin, issuerId: selectedIssuer.id });
    }
    if (!(selectedIssuer === null || selectedIssuer === void 0 ? void 0 : selectedIssuer.id)) {
        throw new Error("Credentials Error: missing a valid selected issuer");
    }
    return (React.createElement("form", { className: "flex flex-col items-center", onSubmit: handleSubmit },
        React.createElement("div", { className: "w-full" },
            React.createElement(RouteTitle, { className: "mb-3 font-bold leading-none md:mb-4" }, "Enter your credentials")),
        React.createElement("div", { className: "mb-2 flex w-full flex-col space-y-4 md:mb-4" },
            React.createElement(TextField, { type: "text", name: "username", className: "username", id: "username", value: username, onChange: handleInputChange, label: (selectedIssuer === null || selectedIssuer === void 0 ? void 0 : selectedIssuer.usernameFieldPlaceholder) || "User ID", required: true, autoCapitalize: "off", autoCorrect: "off", icon: React.createElement(Image, { src: "/assets/icons/lock.svg", className: "text-gray-200" }) }),
            React.createElement(TextField, { type: "password", name: "password", className: "password", id: "password", value: password, onChange: handleInputChange, label: (selectedIssuer === null || selectedIssuer === void 0 ? void 0 : selectedIssuer.passwordFieldPlaceholder) || "Password", required: true, icon: React.createElement(Image, { src: "/assets/icons/lock.svg", className: "text-gray-200" }) }),
            (selectedIssuer === null || selectedIssuer === void 0 ? void 0 : selectedIssuer.pin) ? (React.createElement(TextField, { id: "pin", name: "pin", type: "password", onChange: handleInputChange, placeholder: (selectedIssuer === null || selectedIssuer === void 0 ? void 0 : selectedIssuer.thirdFieldPlaceholder) || "PIN", required: true, icon: React.createElement(Image, { src: "/assets/icons/lock.svg", className: "text-gray-200" }) })) : null),
        React.createElement(Button, { id: "submit-credentials" }, "Submit")));
}
export default LoginForm;
